import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserProfileService } from '@src/app/services/user-managment/user-profile/user-profile.service';
import { log } from 'console';
import { CountryISO } from 'ngx-intl-tel-input';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css']
})
export class EditProfileComponent implements OnInit {

  subscription = new Subscription();
  isChangePasswordExpanded = false;
  isSavedSuccessfully = false;
  CountryISO = CountryISO


  constructor(public translate: TranslateService,public  userProfileService : UserProfileService, public router : Router) { }

  ngOnInit(): void {
    this.userProfileService.initProfileForm()
    this.userProfileService.initChangePasswordForm()
    this.userProfileService.getUserProfile();

    const client = this.userProfileService.user


    this.profileForm.patchValue({
      firstName: client.firstName,
      lastName: client.lastName,
      userPhoneNumber: client.phoneNumber
    });

    this.subscription.add(
      this.userProfileService.notify.subscribe({
        next: (data) => {
          if (data === 2) {
            this.isSavedSuccessfully = true;
            this.router.navigate(['userProfile']);
          }else if(data === 0){
            const client = this.userProfileService.user
            this.profileForm.patchValue({
              firstName: client.firstName,  
              lastName: client.lastName,
              userPhoneNumber: client.phoneNumber
            });

            
          }
        }
    }))


  }


get profileForm(){
  return this.userProfileService.profileForm
}
get changePasswordForm() {
  return this.userProfileService.changePasswordForm;
}

get isLoading() {
  return this.userProfileService.isLoading;
}

get getFirstNameErrorMessage() {
  return this.userProfileService.getFirstNameErrorMessage;
}

get getLastNameErrorMessage() {
  return this.userProfileService.getLastNameErrorMessage;
}

get getPhoneErrorMessage() {
  return this.userProfileService.getPhoneErrorMessage;
}

get getPasswordErrorMessage() {
  return this.userProfileService.getPasswordErrorMessage;
}

get email() {
  return this.userProfileService.user.email;
}

get lang() {
  return this.translate.currentLang === 'en' ? 'en' : 'ar';
}

onSubmit(){
  console.log('hElllo');
  
  if(this.userProfileService.profileForm.valid){
          const phone = this.userProfileService.profileForm.get('userPhoneNumber');
      if(phone && phone.value){
        phone.setValue(phone.value.number)        
      }
    this.userProfileService.editUserProfile()
}
}

onChangePassword(){
  if(this.userProfileService.changePasswordForm.valid){
    this.userProfileService.changePassword()
  }
}

canDeactivate(): boolean {
  if ((this.profileForm.dirty || this.changePasswordForm.dirty) && !this.isSavedSuccessfully) {
    return confirm('You have unsaved changes. Do you really want to leave?');
  }
  return true;
}

ngOnDestroy(): void {
  this.subscription.unsubscribe();
}

}
